<div class="container mt-5">
  <!-- Filter Section -->
  <dx-data-grid
    id="gridContainer"
    [dataSource]="datas"
    [showColumnLines]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    [columnMinWidth]="50"
    [columnAutoWidth]="true"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-export [enabled]="false" [allowExportSelectedData]="true"></dxo-export>

    <dxi-column caption="Mã chỉ định" dataField="orderType.code"></dxi-column>
    <dxi-column caption="Tên chỉ định" dataField="orderType.name"></dxi-column>
    <dxi-column caption="Giá bán" format=",##0.###" dataField="displayPrice"></dxi-column>
    <!--<dxi-column caption="" cellTemplate="cellDetailLink" [fixed]="true" [width]="65" fixedPosition="right"></dxi-column>
    <div *dxTemplate="let cellInfo of 'cellDetailLink'">
      <a title="" class="a-link" *ngIf="cellInfo.data.isValid"
         (click)="showDetail(cellInfo.data)">
        <span class="fa fa-fw fa-info-circle"></span>
        Xem
      </a>
    </div>-->
    <div *dxTemplate="let item of 'cellTemplate'">
    </div>
  </dx-data-grid>
</div>


